import * as React from 'react';
import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import type { CustomRouteComponentProps } from 'react-router-dom';
import { compose } from 'redux';

import type { RootState } from 'af-reducers';

import PagePermissions from 'ab-enums/pagePermissions.enum';

import CLIENT from 'af-constants/routes/client';

import DisabledFeatures from 'ab-common/environment/disabledFeatures';

import type { LinkProps, SeparatorProps } from 'af-components/SideNav/SideNav';
import SideNav from 'af-components/SideNav/SideNav';

type OwnProps = CustomRouteComponentProps;

type Props = OwnProps & ConnectedProps<typeof connector>;

const OrganizationSideNav: React.FC<Props> = (props) => {
	const { location: { state: { orgAlias }, pathname }, userData } = props;

	const links: (LinkProps | SeparatorProps)[] = React.useMemo(() => {
		let constantLinks = [{
			visibleFor: PagePermissions.ORGANIZATION,
			url: CLIENT.ORGANIZATION.MEMBERS(orgAlias),
			label: 'Users',
			icon: 'icon-users',
			isActive: pathname.startsWith(CLIENT.ORGANIZATION.MEMBERS(orgAlias)),
			userData,
		},
		{
			visibleFor: PagePermissions.ORGANIZATION,
			url: CLIENT.ORGANIZATION.SETTINGS.INFO(orgAlias),
			label: 'Organization Settings',
			icon: 'icon-settings',
			isActive: pathname.startsWith(CLIENT.ORGANIZATION.SETTINGS.SIDENAV(orgAlias)),
			userData,
		},
		{
			visibleFor: PagePermissions.ORGANIZATION,
			url: CLIENT.ORGANIZATION.COMPANIES(orgAlias),
			label: 'Companies',
			icon: 'icon-work',
			isActive: pathname.startsWith(CLIENT.ORGANIZATION.COMPANIES(orgAlias)),
			userData,
		}];

		if (!DisabledFeatures.OrganizationDocuments) {
			const [first, ...rest] = constantLinks;
			constantLinks = [
				first,
				{
					visibleFor: PagePermissions.ORGANIZATION,
					url: CLIENT.ORGANIZATION.DOCUMENTS(orgAlias),
					label: 'JHA Documents',
					icon: 'icon-folder_open',
					isActive: pathname.startsWith(CLIENT.ORGANIZATION.DOCUMENTS(orgAlias)),
					userData,
				},
				...rest,
			];
		}

		return constantLinks;
	}, [orgAlias, pathname, userData]);

	return (
		<SideNav
			links={links}
		/>
	);
};

function mapStateToProps(state: RootState) {
	const { userData } = state.user;
	if (!userData) {
		throw new Error('User not logged in');
	}

	return {
		userData,
	};
}

const connector = connect(mapStateToProps);

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(OrganizationSideNav);
